import * as tslib_1 from "tslib";
import { Component, Inject } from "vue-property-decorator";
import { H3Field } from 'h3-mobile-vue';
import { SystemControl } from "../controls/system-control";
import { userApi } from "@cloudpivot/api";
import { StaffSelectorMapping } from '@cloudpivot/form/src/common/components/form-staff-selector/staff-selector-mappings';
let MobileSystemControl = class MobileSystemControl extends SystemControl {
    //上下布局模式
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    created() {
        this.getUserInfo();
    }
    getUserInfo() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // 修改人、创建人 支持属性映射功能-- 获取当前人的用户信息
            let mappings = this.control.options.mappings || "";
            let value = this.control.value;
            let query = this.$route.query;
            if (mappings && value && Array.isArray(value)) {
                // 流程表单状态不执行映射
                if (query.isWorkFlow && query.isWorkFlow === 'true' || query.edit) {
                    return;
                }
                if (this.control.writable) {
                    let { data } = yield userApi.getUserInfo(value[0].id);
                    this.ctrl.value = [data];
                    StaffSelectorMapping.mappingOperate(this.ctrl.value, mappings, this);
                }
            }
        });
    }
};
tslib_1.__decorate([
    Inject()
], MobileSystemControl.prototype, "layoutTypeFn", void 0);
MobileSystemControl = tslib_1.__decorate([
    Component({
        name: "system-control",
        components: {
            H3Field,
        }
    })
], MobileSystemControl);
export default MobileSystemControl;
